import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type SkillIconName =
  | 'away'
  | 'check'
  | 'chevron'
  | 'close'
  | 'external'
  | 'merge'
  | 'plus'
  | 'rows'
  | 'search'
  | 'trash';

@Component({
  selector: 'app-skill-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './skill-icon.component.html',
  styles: [':host { display: inline-flex; }'],
})
export class SkillIconComponent {
  @Input({ required: true }) name!: SkillIconName;
  @Input() size = 18;
}
